// Çok dilli alanları aktif dile göre çözen yardımcılar
import i18n from "../i18n";

export function resolveLocalizedField(value, fallback = "") {
    // value; string ya da { tr, en, ar } olabilir
    if (value == null) return fallback;
    
    // Eğer string ise, JSON string olup olmadığını kontrol et
    if (typeof value === "string") {
        try {
            // JSON string olup olmadığını kontrol et
            const parsed = JSON.parse(value);
            if (parsed && typeof parsed === "object") {
                // JSON string ise, dile göre çöz
                const currentLng = i18n.language?.split("-")?.[0] || "tr";
                const result = parsed?.[currentLng] || parsed?.tr || parsed?.en || parsed?.ar || fallback;
                // console.log("resolveLocalizedField (JSON):", { value, currentLng, result });
                return result;
            }
        } catch (e) {
            // JSON parse edilemezse normal string olarak döndür
            // console.log("resolveLocalizedField (string):", { value, result: value || fallback });
            return value || fallback;
        }
    }
    
    // Obje ise direkt dile göre çöz
    if (typeof value === "object") {
        const currentLng = i18n.language?.split("-")?.[0] || "tr";
        const result = value?.[currentLng] || value?.tr || value?.en || value?.ar || fallback;
        // console.log("resolveLocalizedField (object):", { value, currentLng, result });
        return result;
    }
    
    return fallback;
}

export function pickByLang(obj = {}) {
    // { tr: '...', en: '...', ar: '...' } -> aktif dile göre seç
    const currentLng = i18n.language?.split("-")?.[0] || "tr";
    return obj?.[currentLng] || obj?.tr || obj?.en || obj?.ar || "";
}

export function resolveByLangSuffix(objectWithFields = {}, baseKey, fallback = "") {
    // name_tr, name_en, name_ar gibi alan adlarından aktif dile göre seçer
    if (!objectWithFields || !baseKey) return fallback;
    const currentLng = i18n.language?.split("-")?.[0] || "tr";
    const keyMap = {
        tr: `${baseKey}_tr`,
        en: `${baseKey}_en`,
        ar: `${baseKey}_ar`,
    };
    const key = keyMap[currentLng];
    const result =
        objectWithFields?.[key] ??
        objectWithFields?.[keyMap.tr] ??
        objectWithFields?.[keyMap.en] ??
        objectWithFields?.[keyMap.ar] ??
        fallback;
    return result;
}

// Kategori slug'larını dil bazlı yönetmek için yardımcılar
export function getCategorySlug(category, lang = null) {
    // Aktif dili al veya parametre olarak verilen dili kullan
    const currentLang = lang || i18n.language?.split("-")?.[0] || "tr";
    
    // Önce slug_${lang} formatını dene
    const slugKey = `slug_${currentLang}`;
    if (category?.[slugKey]) {
        return category[slugKey];
    }
    
    // Fallback: slug alanını dene
    if (category?.slug) {
        return category.slug;
    }
    
    // Son çare: kategori ID'sini döndür
    return category?.id || "";
}

export function getCategoryBySlug(categories, targetSlug, lang = null) {
    if (!Array.isArray(categories) || !targetSlug) return undefined;

    // 1) Aktif dile göre kontrol (varsa)
    const currentLang = lang || i18n.language?.split("-")?.[0] || "tr";
    const preferKey = `slug_${currentLang}`;
    let found = categories.find(cat => (cat?.[preferKey] || "") === targetSlug);
    if (found) return found;

    // 2) Tüm dil slug alanlarında ara (slug_tr, slug_en, slug_ar)
    const keys = ["slug_tr", "slug_en", "slug_ar", "slug"];
    found = categories.find(cat => keys.some(k => (cat?.[k] || "") === targetSlug));
    if (found) return found;

    // 3) Son çare: ID eşleşmesi
    return categories.find(cat => (cat?.id || "") === targetSlug);
}

export function generateSlug(text, lang = "tr") {
    // Basit slug oluşturucu
    if (!text) return "";
    
    return text
        .toLowerCase()
        .replace(/[ğ]/g, 'g')
        .replace(/[ü]/g, 'u')
        .replace(/[ş]/g, 's')
        .replace(/[ı]/g, 'i')
        .replace(/[ö]/g, 'o')
        .replace(/[ç]/g, 'c')
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim('-');
}


